import React from 'react';
import PropTypes from 'prop-types';
import DetailsCell from './details_cell';
import { VIEW_MODES } from '../../constants';
import { componentText } from '../../utils/i18n_utils';

const t = (key, fallback) => componentText(`legend_row.${key}`, fallback);

// Mobile shows the abbreviated labels; every other view the full ones.
const LegendRow = ({ viewMode, holeByHoleView }) => {
  const short = viewMode === VIEW_MODES.MOBILE;

  return (
    <tr className="lbv2__details-legend-row">
      <DetailsCell className="lbv2__details-legend" colSpan={100}>
        <div className="lbv2__starting">
          <div className="lbv2__starting-shape"></div>
          <div className="lbv2__starting-text">
            {short ? t('starting_hole_short', 'Starting') : t('starting_hole', 'Starting Hole')}
          </div>
        </div>
        <div className="lbv2__eagle">
          <div className={`lbv2__eagle-shape ${holeByHoleView}`}></div>
          <div className="lbv2__eagle-text">
            {short ? t('eagle_or_better_short', 'Eagle -') : t('eagle_or_better', 'Eagle Or Better')}
          </div>
        </div>
        <div className="lbv2__birdie">
          <div className={`lbv2__birdie-shape ${holeByHoleView}`}></div>
          <div className="lbv2__birdie-text">{t('birdie', 'Birdie')}</div>
        </div>
        <div className="lbv2__par">
          <div className="lbv2__par-shape"></div>
          <div className="lbv2__par-text">{t('par', 'Par')}</div>
        </div>
        <div className="lbv2__bogey">
          <div className={`lbv2__bogey-shape ${holeByHoleView}`}></div>
          <div className="lbv2__bogey-text">{t('bogey', 'Bogey')}</div>
        </div>
        <div className="lbv2__d-bogey">
          <div className={`lbv2__d-bogey-shape ${holeByHoleView}`}></div>
          <div className="lbv2__d-bogey-text">
            {short ? t('double_bogey_or_worse_short', 'D Bogey +') : t('double_bogey_or_worse', 'Double Bogey Or Worse')}
          </div>
        </div>
      </DetailsCell>
    </tr>
  );
};

LegendRow.propTypes = {
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
  holeByHoleView: PropTypes.string,
};

export default LegendRow;
